import { render } from "./UploadFile.vue?vue&type=template&id=f90c50ba&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=f90c50ba&scoped=true&lang=css"

import exportComponent from "/kaam/build/sicpa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f90c50ba"]])

export default __exports__